var _defs, _path, _path2, _path3, _line, _path4, _line2, _line3, _line4, _line5, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaymentinfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 160 160",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n            .cls-1{\r\n                fill:none;\r\n                stroke:#9384be;\r\n                stroke-linecap:round;\r\n                stroke-linejoin:round;\r\n                stroke-width:6.61px;\r\n            }\r\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M156,40.35H101.8A20.33,20.33,0,0,0,86,47.87l-4.64,5.7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M104.3,53.57,89.59,68.41a8.57,8.57,0,0,0,0,12,8.41,8.41,0,0,0,11.93,0l11.06-11.15a17.16,17.16,0,0,0,18.94,2.92,24.86,24.86,0,0,0,4.85-2.92"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M156,89.91H143.18s-3.44,7.48-10.31,10.58"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 156,
    y1: 27.13,
    x2: 156,
    y2: 96.52
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M113,53.57h-85a7.81,7.81,0,0,0-7.56,8V76.7"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 63.48,
    y1: 116.35,
    x2: 10.61,
    y2: 116.35
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 83.3,
    y1: 96.52,
    x2: 43.65,
    y2: 96.52
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 30.43,
    y1: 96.52,
    x2: 17.22,
    y2: 96.52
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 4,
    y1: 76.7,
    x2: 50.26,
    y2: 76.7
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.52,116.35v8.47A7.78,7.78,0,0,0,28,132.87h97.37a7.78,7.78,0,0,0,7.49-8.05V73.39"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentinfo);
export default __webpack_public_path__ + "static/media/payment info.2f2f6180b4de74e7308d03a90b502b65.svg";
export { ForwardRef as ReactComponent };